/**
 * SubjectBuddyLogo renders the shared brand image from the public folder.
 */
export default function SubjectBuddyLogo({
  size = 44,
  alt = "SubjectBuddy",
  style = {},
  ...props
}) {
  const height = typeof size === "number" ? `${size}px` : size;
  const baseUrl = process.env.PUBLIC_URL || "";
  const logoSrc = `${baseUrl}/logos_all/subject-buddy-logo-mini_300x75.png`;
  const logoSrcSet = [
    `${baseUrl}/logos_all/subject-buddy-logo-mini_300x75.png 300w`,
    `${baseUrl}/logos_all/subject-buddy-logo-small_400x100.png 400w`,
    `${baseUrl}/logos_all/subject-buddy-logo-mobile_600x150.png 600w`,
    `${baseUrl}/logos_all/subject-buddy-logo-tablet_800x200.png 800w`,
    `${baseUrl}/logos_all/subject-buddy-logo-desktop_1200x300.png 1200w`,
    `${baseUrl}/logos_all/subject-buddy-logo-retina_2000x500.png 2000w`,
  ].join(", ");

  return (
    <img
      src={logoSrc}
      srcSet={logoSrcSet}
      sizes="180px"
      alt={alt}
      style={{
        display: "block",
        height,
        width: "auto",
        maxWidth: "100%",
        userSelect: "none",
        objectFit: "contain",
        ...style,
      }}
      decoding="async"
      {...props}
    />
  );
}
